// src/AppInsights.ts
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { globalConfig } from './globalConfig';

export const reactPlugin = new ReactPlugin();

let appInsights: ApplicationInsights | null = null;

export const initializeAppInsights = () => {
  if (appInsights) return appInsights;

  const connectionString = globalConfig.getValue('appInsightsConnectionString');

  if (!connectionString) {
    console.warn("App Insights Connection String not available yet.");
    return null;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString, // Using saved value
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      correlationHeaderExcludedDomains: [],
      disableFetchTracking: false,
      disableAjaxTracking: false,
      samplingPercentage: 100,
    }
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    if (!envelope.tags) {
      envelope.tags = {};
    }
    envelope.tags["ai.cloud.role"] = "PPA-Frontend";
  });

  appInsights.trackPageView();

  return appInsights;
};

export { appInsights };